import { render, staticRenderFns } from "./MonsterDetail.vue?vue&type=template&id=5b1bcdf6&lang=pug&"
import script from "./MonsterDetail.vue?vue&type=script&lang=ts&"
export * from "./MonsterDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports